
// GET Action
export class getMenuBar {
    static readonly type = '[Menu] Get';
}